<template>
  <div class="pcm-b-wrapper" id="pcm-b-wrapper">
    <img class="pcm-b-bg" src="@/assets/images/pc/pageB/v2/bg.webp" alt="" />
    <div class="pcm-b-stage">
      <img
        class="pcm-b-hero"
        src="@/assets/images/pc/pageB/v2/hero.webp"
        alt=""
      />
      <img
        class="pcm-b-title"
        src="@/assets/images/pc/pageB/v2/title.webp"
        alt="别光看封面，点开更有戏"
      />
      <img
        class="pcm-b-phone"
        src="@/assets/images/pc/pageB/v2/phone.webp"
        alt=""
      />
      <img
        class="pcm-b-cta"
        src="@/assets/images/pc/pageB/v2/cta.webp"
        alt="点开看一集"
      />
      <img class="pcm-b-qr" :src="qrImg" alt="下载二维码" />

      <div class="pcm-b-nav">
        <div class="pcm-b-brand">
          <img
            class="pcm-b-brand-logo"
            src="@/assets/images/pc/pageB/v2/logo.png"
            alt="黄果免费看"
          />
        </div>
        <div class="pcm-b-services">
          <div v-if="swUrl" class="pcm-b-service" @click="toContact(swUrl)">
            <img
              class="pcm-b-service-icon"
              src="@/assets/images/pc/pageB/v2/icon-sw.png"
              alt=""
            />
            <span class="pcm-b-service-text">商务合作</span>
          </div>
          <div v-if="qdUrl" class="pcm-b-service" @click="toContact(qdUrl)">
            <img
              class="pcm-b-service-icon"
              src="@/assets/images/pc/pageB/v2/icon-qd.png"
              alt=""
            />
            <span class="pcm-b-service-text">渠道合作</span>
          </div>
          <div v-if="tgUrl" class="pcm-b-service" @click="toContact(tgUrl)">
            <img
              class="pcm-b-service-icon"
              src="@/assets/images/pc/pageB/v2/icon-tg.png"
              alt=""
            />
            <span class="pcm-b-service-text">官方群组</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";

export default {
  props: ["qrImg", "configs", "version"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-b-wrapper",
        resize: true
      },
      false
    );
  },
  beforeDestroy() {
    autofit.off("#pcm-b-wrapper");
  },
  methods: {
    toContact(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-b-wrapper {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  background: #fdc5ca;

  .pcm-b-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
    pointer-events: none;
  }

  .pcm-b-stage {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1920px;
    height: 1080px;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  .pcm-b-hero {
    position: absolute;
    left: 528px;
    top: 24px;
    width: 1387px;
    height: 1055px;
    z-index: 1;
    pointer-events: none;
  }

  .pcm-b-title {
    position: absolute;
    left: 32px;
    top: 88px;
    width: 846px;
    height: 716px;
    z-index: 2;
    pointer-events: none;
  }

  .pcm-b-phone {
    position: absolute;
    left: 1440px;
    top: 224px;
    width: 481px;
    height: 851px;
    z-index: 3;
    pointer-events: none;
  }

  .pcm-b-cta {
    position: absolute;
    left: 64px;
    top: 792px;
    width: 604px;
    height: 211px;
    z-index: 4;
    pointer-events: none;
  }

  .pcm-b-qr {
    position: absolute;
    left: 84px;
    top: 812px;
    width: 170px;
    height: 170px;
    z-index: 5;
    background: #fff;
  }

  .pcm-b-nav {
    position: absolute;
    left: 0;
    top: 0;
    width: 1920px;
    height: 90px;
    box-sizing: border-box;
    padding: 0 206px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
  }

  .pcm-b-brand {
    position: absolute;
    left: 80px;
    top: 13px;
    width: 289px;
    height: 84px;
  }

  .pcm-b-brand-logo {
    display: block;
    width: 289px;
    height: 84px;
  }

  .pcm-b-services {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-left: auto;
  }

  .pcm-b-service {
    width: 160px;
    height: 50px;
    box-sizing: border-box;
    border-radius: 25px;
    background: #fc0466;
    display: flex;
    align-items: center;
    padding-left: 16px;
    gap: 8px;
    cursor: pointer;
  }

  .pcm-b-service-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    filter: brightness(0) invert(1);
  }

  .pcm-b-service-text {
    font-size: 20px;
    line-height: 20px;
    font-family: -apple-system, "PingFang SC", "Helvetica Neue",
      "Microsoft YaHei", sans-serif;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    white-space: nowrap;
  }
}
</style>
